var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-nocheck
import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import { withTranslation } from "react-i18next";
import PlacesAutocomplete, { geocodeByAddress, getLatLng, } from "react-places-autocomplete";
import { Row } from "antd";
import BlueButton from "../bluebutton";
import "./index.scss";
var GoogleComp;
var marker;
class MapPlacesInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapApiLoaded: false,
            mapInstance: null,
            mapApi: null,
            geoCoder: null,
            places: [],
            center: this.props.center,
            zoom: this.props.zoom,
            address: "",
            draggable: true,
            lat: this.props.center.lat,
            lng: this.props.center.lng,
        };
        this._onClick = ({ x, y, lat, lng, event }) => {
            this.setState({
                lat: lat,
                lng: lng,
            });
            this.setCurrentLocation(true);
        };
        this.apiHasLoaded = (map, maps) => {
            this.setState({
                mapApiLoaded: true,
                mapInstance: map,
                mapApi: maps,
            });
            this.addMyLocationButton();
        };
        this.setAddress = (address) => {
            this.setState({ address: address });
            // this.props.handleAddressChange(address);
        };
        this.handleSelect = (value) => __awaiter(this, void 0, void 0, function* () {
            const results = yield geocodeByAddress(value);
            console.log(value);
            const latLng = yield getLatLng(results[0]);
            console.log("latlng >>> >> >> > " + latLng.lat);
            this.setAddress(value);
            this.setState({
                center: [latLng.lat, latLng.lng],
                lat: latLng.lat,
                lng: latLng.lng,
            });
            GoogleComp.state.mapInstance.setZoom(20);
        });
        this.updateAddress = () => {
            const { address, lat, lng } = this.state;
            this.props.onOk({ address: address, lat: lat, lng: lng });
        };
    }
    componentDidMount() {
        this.setCurrentLocation(false);
        GoogleComp = this;
    }
    componentWillUnmount() {
        GoogleComp = null;
        // this.state.address = ""
    }
    addMyLocationButton() {
        var controlDiv = document.createElement("div");
        var firstChild = document.createElement("button");
        firstChild.style.backgroundColor = "#fff";
        firstChild.style.border = "none";
        firstChild.style.outline = "none";
        firstChild.style.width = "38px";
        firstChild.style.height = "38px";
        firstChild.style.borderRadius = "2px";
        firstChild.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
        firstChild.style.cursor = "pointer";
        firstChild.style.marginRight = "12px";
        firstChild.style.padding = "0px";
        firstChild.title = "Your Location";
        controlDiv.appendChild(firstChild);
        var secondChild = document.createElement("div");
        secondChild.style.margin = "10px";
        secondChild.style.width = "18px";
        secondChild.style.height = "18px";
        secondChild.style.backgroundImage =
            "url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)";
        secondChild.style.backgroundSize = "180px 18px";
        secondChild.style.backgroundPosition = "0px 0px";
        secondChild.style.backgroundRepeat = "no-repeat";
        secondChild.id = "you_location_img";
        firstChild.appendChild(secondChild);
        GoogleComp.state.mapInstance.controls[GoogleComp.state.mapApi.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
        firstChild.addEventListener("click", function () {
            // var imgX = "0";
            // var animationInterval = setInterval(function () {
            //     if (imgX == "-18") imgX = "0";
            //     else imgX = "-18";
            //     //$('#you_location_img').css('background-position', imgX+'px 0px');
            // }, 500);
            // if (navigator.geolocation) {
            GoogleComp.setCurrentLocation(false);
            //GoogleComp._generateAddress();
            // }
        });
        // firstChild.addEventListener("click", function () {
        //   var imgX = "0";
        //   var animationInterval = setInterval(function () {
        //     if (imgX == "-18") imgX = "0";
        //     else imgX = "-18";
        //     document?.getElementsByClassName("you_location_img")[0]?.setAttribute("style",
        //         `${
        //           "margin:10px;width:18px;height:18px;background-image:url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png);" +
        //           "background-size:180px 18px;background-position:0px 0px;background-repeat:no-repeat;"
        //         }` +
        //           "background-position:" +
        //           imgX +
        //           "px 0px;"
        //       );
        //   }, 500);
        //   if (navigator.geolocation) {
        //     GoogleComp.setCurrentLocation(false);
        //     try {
        //     // GoogleComp?._generateAddress();
        //     } catch (e: any) {
        //       console.log(e)
        //     }
        // }
        // });
    }
    setCurrentLocation(isCordProvided) {
        navigator.geolocation.getCurrentPosition((position) => {
            if (position.coords.latitude !== null &&
                position.coords.longitude !== null &&
                GoogleComp !== null &&
                GoogleComp.state.mapApi !== null) {
                if (!isCordProvided) {
                    GoogleComp.setState({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                }
                const geocoder = new GoogleComp.state.mapApi.Geocoder();
                geocoder.geocode({
                    location: {
                        lat: parseFloat(GoogleComp.state.lat),
                        lng: parseFloat(GoogleComp.state.lng),
                    },
                }, (results, status) => {
                    console.log(results);
                    console.log(status);
                    const myLatlng = {
                        lat: GoogleComp.state.lat,
                        lng: GoogleComp.state.lng,
                    };
                    if (GoogleComp !== null && GoogleComp.state.mapInstance) {
                        GoogleComp.state.mapInstance.setCenter(myLatlng);
                        GoogleComp.state.mapInstance.setZoom(18);
                        if (marker) {
                            marker.setMap(null);
                        }
                        marker = new GoogleComp.state.mapApi.Marker({
                            position: myLatlng,
                        });
                        marker.setMap(GoogleComp.state.mapInstance);
                    }
                    if (status === "OK") {
                        if (results[0]) {
                            //this.zoom = 12;
                            this.setAddress(results[0].formatted_address);
                        }
                        else {
                            console.log("Unable to get the coordinates1");
                        }
                    }
                    else {
                        console.log("Geocoder failed due to: " + status);
                    }
                });
            }
        }, function (error) {
            console.log("Unable to get the coordinates");
            console.log(error);
        });
    }
    // private onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    //   console.log(e.key);
    //   if (e.key === "Enter") {
    //     this.handleSelect(this.state.address);
    //   }
    // };
    render() {
        const { t, confirm_location, closeText, typeAddress } = this.props;
        const defaultMapOptions = {
            fullscreenControl: false,
        };
        return (_jsxs("div", { children: [_jsx(PlacesAutocomplete, Object.assign({ value: this.state.address, onChange: this.setAddress, onSelect: this.handleSelect, searchOptions: { componentRestrictions: { country: ["sa"] } } }, { children: ({ getInputProps, suggestions, getSuggestionItemProps, loading, }) => (_jsxs("div", Object.assign({ className: "suggestions mx-4" }, { children: [_jsx("input", Object.assign({ className: "w-100 sansFont suggestionInput rounded" }, getInputProps({ placeholder: typeAddress !== undefined ? typeAddress : 'Type Address' })), void 0), _jsx("div", { children: suggestions.map((suggestion, index) => {
                                    const style = {
                                        backgroundColor: suggestion.active ? "#C3CED0" : "#fff",
                                    };
                                    return (_jsx(React.Fragment, { children: _jsx("div", Object.assign({}, getSuggestionItemProps(suggestion, { style }), { children: suggestion.description }), void 0) }, index));
                                }) }, void 0)] }), void 0)) }), void 0), _jsxs("div", Object.assign({ style: {
                        position: "relative",
                        top: "-22px",
                    } }, { children: [_jsx("div", Object.assign({ onClick: this.props.handleClose, className: "simpleNormMed closeTextButon rightEn" }, { children: closeText !== undefined ? closeText : 'CLOSE' }), "closeButton"), _jsx("div", Object.assign({ style: { height: "70vh", width: "100%" } }, { children: _jsx(GoogleMapReact, { center: this.state.center, zoom: this.state.zoom, draggable: this.state.draggable, options: defaultMapOptions, onClick: this._onClick, bootstrapURLKeys: {
                                    key: this.props.googleMapKey,
                                    libraries: ["places", "geometry"],
                                }, yesIWantToUseGoogleMapApiInternals: true, onGoogleApiLoaded: ({ map, maps }) => this.apiHasLoaded(map, maps) }, void 0) }), void 0), _jsx("div", Object.assign({ className: "mt-3" }, { children: _jsx(Row, { children: _jsx(BlueButton, { contentPadding: "leftEn", disabled: !this.state.address, buttonClass: "blueButton simpleNormReg text-uppercase  blueButton-map", text: confirm_location, onClick: this.updateAddress }, "OkButton") }, void 0) }), void 0)] }), void 0)] }, void 0));
    }
}
MapPlacesInput.defaultProps = {
    center: { lat: 24.713, lng: 46.675 },
    zoom: 11,
};
export default withTranslation()(MapPlacesInput);
